import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarCotacao(api, parametros) {        
    let retorno = {};
    
    await api.santriGET('/rest/cotacao', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno;
  },
  
  async buscarItensCotacao(api, parametros) {      
    parametros.operacao = 'buscarItensCotacao';
    let retorno = {};
    
    await api.santriGET('/rest/cotacao', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno; 
  },
  
  async buscarListaCotacao(api) { 
    let parametros = { operacao :'buscarListaCotacao'}
    let retorno = {};
    
    await api.santriGET('/rest/cotacao', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno;
  },
  
  async atualizarCotacao(api, parametros) { 
    parametros.operacao = 'atualizarCotacao';
    let retorno = {};
    
    await api.santriPOST('/rest/cotacao', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCotacao.js